// extracted by mini-css-extract-plugin
export default {"productcard":"WV","productimage":"XV","username":"YV","multiBagName":"ZV","productinfo":"aW","productinfoinner":"bW","productname":"cW","productsubheader":"eW","productdescription":"fW","productnumbers":"gW","productnumberstitle":"hW","productnumbersitem":"iW","number":"jW","numbertext":"kW","tabs":"lW","benefitsblock":"mW","benefit":"nW","benefitname":"oW","benefitdescription":"pW","ingredientsblock":"qW","tipsblock":"rW","mobileonly":"sW"};
    if(module.hot) {
      // 1743628928134
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  